type DragType = {
    el: HTMLElement | undefined,
    mouseStartX: number,
    mouseStartY: number,
    elStartX: number,
    elStartY: number,
    oldTransition: string,
};

export type DraggableDialogsManager = {
    init: () => void,
    destroy: () => void,
};

/**
 * <v-dialogs content-class="draggable"></v-dialog>
 *
 * https://github.com/vuetifyjs/vuetify/issues/4058
 */
export default function createDraggableDialogsManager(): DraggableDialogsManager {
    const d: DragType = {
        el: undefined,
        mouseStartX: 0,
        mouseStartY: 0,
        elStartX: 0,
        elStartY: 0,
        oldTransition: '',
    };

    const onMouseDown = (e: MouseEvent): void => {
        const closestDialog = (e.target as HTMLElement).closest('.v-dialog.v-dialog--active.draggable');
        if (e.button === 0 &&
            closestDialog != null &&
            (e.target as HTMLElement).classList.contains('v-card__title')) {
            d.el = closestDialog as HTMLElement;
            d.mouseStartX = e.clientX;
            d.mouseStartY = e.clientY;
            d.elStartX = d.el.getBoundingClientRect().left;
            d.elStartY = d.el.getBoundingClientRect().top;
            d.el.style.position = 'fixed';
            d.el.style.margin = '0';
            d.oldTransition = d.el.style.transition;
            d.el.style.transition = 'none';
        }
    };

    const onMouseMove = (e: MouseEvent): void => {
        if (d.el === undefined) return;
        d.el.style.left = Math.min(
            Math.max(d.elStartX + e.clientX - d.mouseStartX, 0),
            window.innerWidth - d.el.getBoundingClientRect().width
        ) + 'px';
        d.el.style.top = Math.min(
            Math.max(d.elStartY + e.clientY - d.mouseStartY, 0),
            window.innerHeight - d.el.getBoundingClientRect().height
        ) + 'px';
    };

    const onMouseUp = (): void => {
        if (d.el === undefined) return;
        d.el.style.transition = d.oldTransition;
        d.el = undefined;
    };

    const init = (): void => {
        document.addEventListener('mousedown', onMouseDown);
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    };

    const destroy = (): void => {
        document.removeEventListener('mousedown', onMouseDown);
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
    };

    return { init, destroy };
}
